import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  min-height: 100vh;
}

.access-page {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 32px;
  color: #161616;
  background: linear-gradient(90deg, rgba(15, 98, 254, 0.08) 1px, transparent 1px), linear-gradient(180deg, rgba(15, 98, 254, 0.06) 1px, transparent 1px), #f4f4f4;
  background-size: 48px 48px;
}

.access-shell {
  width: min(1040px, 100%);
  min-height: 640px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 440px;
  border: 1px solid #d0d0d0;
  background: #ffffff;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.12);
}

.access-brand {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 32px;
  padding: 56px;
  color: #f4f4f4;
  background: linear-gradient(135deg, rgba(15, 98, 254, 0.18), transparent 34%), linear-gradient(180deg, #161616 0%, #262626 100%);
}

.product-mark {
  width: 48px;
  height: 48px;
  display: grid;
  place-items: center;
  border: 1px solid #525252;
  background: #0f62fe;
  color: #ffffff;
  font-weight: 700;
}

.eyebrow,
.metric-label {
  display: block;
  margin-bottom: 8px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #0f62fe;
}

.access-brand .eyebrow {
  color: #78a9ff;
}

h1,
h2 {
  margin: 0;
  letter-spacing: 0;
}

h1 {
  font-size: clamp(44px, 7vw, 84px);
  line-height: 0.95;
  font-weight: 600;
}

h2 {
  font-size: 28px;
  line-height: 1.2;
  font-weight: 600;
}

.brand-copy {
  max-width: 520px;
  margin: 24px 0 0;
  color: #c6c6c6;
  font-size: 17px;
  line-height: 1.7;
}

.brand-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border-top: 1px solid #393939;
  border-left: 1px solid #393939;
}

.brand-grid > div {
  padding: 18px;
  border-right: 1px solid #393939;
  border-bottom: 1px solid #393939;
}

.brand-grid strong {
  display: block;
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
}

.auth-panel {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 40px;
  border-left: 1px solid #d0d0d0;
  background: #ffffff;
}

.auth-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}

.env-pill {
  padding: 6px 10px;
  border: 1px solid #d0d0d0;
  background: #f4f4f4;
  color: #525252;
  font-size: 12px;
  font-weight: 600;
}

.segmented-control {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  border: 1px solid #c6c6c6;
  background: #f4f4f4;
}

.segmented-control button {
  height: 44px;
  border: 0;
  border-right: 1px solid #c6c6c6;
  background: transparent;
  color: #525252;
  font-size: 14px;
  font-weight: 600;
}

.segmented-control button:last-child {
  border-right: 0;
}

.segmented-control button.active {
  background: #161616;
  color: #ffffff;
}

.form-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field span {
  color: #393939;
  font-size: 13px;
  font-weight: 600;
}

.field input {
  width: 100%;
  min-height: 48px;
  padding: 0 14px;
  border: 1px solid #8d8d8d;
  border-radius: 0;
  background: #f4f4f4;
  color: #161616;
  font-size: 15px;
  outline: none;
}

.field input:focus {
  border-color: #0f62fe;
  box-shadow: inset 0 0 0 1px #0f62fe;
  background: #ffffff;
}

.primary-action {
  min-height: 48px;
  border: 1px solid #0f62fe;
  border-radius: 0;
  background: #0f62fe;
  color: #ffffff;
  font-weight: 700;
  transition: background 0.16s ease, border-color 0.16s ease;
}

.primary-action:hover {
  background: #0353e9;
  border-color: #0353e9;
}

.auth-footer {
  margin-top: auto;
  padding-top: 18px;
  border-top: 1px solid #e0e0e0;
  display: grid;
  gap: 6px;
  color: #6f6f6f;
  font-size: 12px;
  line-height: 1.5;
}

@media (max-width: 900px) {
  .access-page {
    padding: 0;
    align-items: stretch;
  }
  .access-shell {
    min-height: 100vh;
    grid-template-columns: 1fr;
    border: 0;
  }
  .access-brand {
    padding: 32px 24px;
  }
  .auth-panel {
    border-left: 0;
    border-top: 1px solid #d0d0d0;
    padding: 28px 24px;
  }
}
@media (max-width: 520px) {
  .brand-grid,
  .form-grid {
    grid-template-columns: 1fr;
  }
  .access-brand {
    gap: 24px;
  }
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loginData: any = {
        password: ''
    };

    public async ngOnInit() {
        await this.service.init();
        const check = this.service.auth.check();
        if (check) {
            this.service.href("/calender");
            return;
        }
        await this.service.render();
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async login() {
        let user = JSON.parse(JSON.stringify(this.loginData));
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        let { code, data } = await wiz.call("login", user);

        if (code == 200) {
            await this.service.auth.init();
            this.service.href("/calender");
        } else {
            await this.alert(data.message || "로그인에 실패했습니다.", 'error');
        }
    }
}

export default PageAccessComponent;